import repository from './repository';
import axios from "axios";

const API = process.env.VUE_APP_API_URL;

let repo = repository('/projects');

// Simple function to get an empty project
repo.blankProject = () => {
    return {
        name: '',
        user_id: ''
    };
};

// Validation logic
function validateName(name) {
    return (name.length >= process.env.VUE_APP_VALIDATION_PROJECT_MIN_NAME_LENGTH && name.length < 250);
}

repo.getConnections = (id) => {
    return axios.post(API + '/project/connections', {project_id: id});
};

repo.getIndexData = () => {
    return axios.get(API + '/project/index');
};

/* Routes for the project Config view */
repo.getProjectConfig = (projectId) => {
    return axios.post(API + '/project/config', {projectId: projectId});
};
repo.saveProjectConfig = (ProjectConfig, projectId) => {
    return axios.post(API + '/project/config/save', {projectConfig: ProjectConfig, projectId: projectId})
};


repo.validate = {
    projectName(name) {
        return validateName(name);
    },
    user(user_id) {
        return user_id > 0;
    }
};

export default repo;
